import React from "react";
import PropTypes from "prop-types";
import uniq from "lodash/uniq";
import flatMap from "lodash/flatMap";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";

import { getWidgetState } from "orion-components/Profiles/Selectors";
import DeviceTree from "orion-components/DeviceManager/DeviceTree/DeviceTree";
import { Translate } from "orion-components/i18n";
import { selectedContextSelector } from "orion-components/ContextPanel/Selectors";

const propTypes = {
	id: PropTypes.string,
	devices: PropTypes.array
};

const defaultProps = {
	devices: []
};

const DeviceManagerWidget = ({ id, devices = [], cameras = [] }) => {
	const enabled = useSelector(state => getWidgetState(state)(id, "enabled"));
	const context = useSelector(state => selectedContextSelector(state));
	const { floorPlanCameras = [], floorPlanDevices = [], floorPlanCompositeDevices = [] } = context || {};
	const entities =
		[...floorPlanCameras, ...floorPlanDevices, ...floorPlanCompositeDevices, ...devices, ...cameras]?.map(
			entity => entity.id
		) || [];
	const allowedEntities = uniq(flatMap(entities));

	return !enabled ? (
		<div />
	) : (
		<div className="widget-wrapper collapsed" data-testid="device-manager-widget">
			<div className="widget-header" data-testid="device-manager-widget-header">
				<div className="cb-font-b2">
					<Translate value="global.profiles.widgets.deviceManager.title" />
				</div>
			</div>

			<div className="widget-content" style={{ display: "flex" }} data-testid="device-manager-widget-content">
				{allowedEntities?.length ? (
					<DeviceTree
						readOnly={true}
						ignoreEmptyGroups={true}
						entitySelectionFilters={{
							allowedEntities
						}}
						autoExpandNodes={true}
						allowDeviceGroupCommands={true}
						addUngroupedDevicesToRoot={true}
					/>
				) : (
					<Typography style={{ margin: "12px auto", color: "#fff" }} align="center" variant="caption">
						<Translate value="global.profiles.widgets.deviceManager.noDevicesAvailable" />
					</Typography>
				)}
			</div>
		</div>
	);
};

DeviceManagerWidget.propTypes = propTypes;
DeviceManagerWidget.defaultProps = defaultProps;

export default DeviceManagerWidget;
